import { useState } from 'react';
import {
    Button,
    Checkbox,
    FormHelperText,
    FormControlLabel,
    Box,
    Tab,
    Tabs,
    Grid,
    TextField,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    FormControl,
    Card,
    CardHeader,
    Dialog,
    IconButton,
    DialogTitle,
    DialogContent,
    Divider,
    DialogActions,
    InputAdornment,
    Tooltip,
} from '@mui/material';
import PropTypes from 'prop-types';
import unsplash from '../../api/unsplash';
import moment from 'moment';
import 'moment/locale/it';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment as DateAdapter } from '@mui/x-date-pickers/AdapterMoment';
import Allegati from '../Allegati';
import CorsiLavoratore from './CorsiLavoratore';
import { Check, Edit, Close, CheckCircle, Error } from '@mui/icons-material';
import GlobalSnackbar from '../Snackbar';
import {
    evaluateCodiceFiscale,
    normalizeCfValue,
} from '../../utils/codiceFiscale';

const DettaglioLavoratore = (props) => {
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(0);
    const [clienti, setClienti] = useState();
    const [lavoratore, setLavoratore] = useState(props.lavoratore);
    const [lavoratoreCopy, setLavoratoreCopy] = useState(props.lavoratore);
    const [sedi, setSedi] = useState([]);
    const [mansioni, setMansioni] = useState([]);
    const [mansioniSicurezza, setMansioniSicurezza] = useState([]);
    const cf = lavoratore?.CF;
    const nome = lavoratore?.Nome;
    const cognome = lavoratore?.Cognome;
    const sesso = lavoratore?.Sesso;
    const dataDiNascita = lavoratore?.DataDiNascita;
    const luogoDiNascita = lavoratore?.LuogoDiNascita;
    const validation = {
        DataAssunzione: false,
        Nome: false,
        Cognome: false,
        Mansione: false,
    };
    const cfStatus = evaluateCodiceFiscale({
        CFTecnico: lavoratore.CFTecnico,
        CF: cf,
        Nome: nome,
        Cognome: cognome,
        Sesso: sesso,
        DataDiNascita: dataDiNascita,
        LuogoDiNascita: luogoDiNascita,
    });

    const fetchData = async () => {
        let responseSedi = await unsplash.get('sedi', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { id: props.lavoratore.Cliente },
        });
        const SediSenzaCantiere = responseSedi.data.data.filter(
            (elm) => elm.Cantiere === 0
        );
        setSedi(SediSenzaCantiere);

        let responseMansioni = await unsplash.get('mansioni', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { id: props.lavoratore.Cliente },
        });

        setMansioni(responseMansioni.data.data);

        let responseClienti = await unsplash.get('clienti', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        setClienti(responseClienti.data.data);

        let responseMansioniSicurezza = await unsplash.get(
            'mansioniSicurezza',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { id: props.cliente, sede: props.lavoratore.Sede },
            }
        );
        setMansioniSicurezza(responseMansioniSicurezza.data.data);
    };

    const handleClickOpen = async () => {
        setOpen(true);
        await fetchData();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);
    };
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    /* ASTM useEffect(() => {
    // è un loop qui carico i dati

    const fetchData = async () => {

      let responseSedi = await unsplash.get("sedi", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.lavoratore.Cliente },
      });
      const SediSenzaCantiere = responseSedi.data.data.filter(
        (elm) => elm.Cantiere === 0
      );
      setSedi(SediSenzaCantiere);

      let responseDettaglioMedicina = await unsplash.get("dettaglioMedicina", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.lavoratore.Sede },
      });

      setDettaglioMedicina(responseDettaglioMedicina.data.data);

      let responseMansioni = await unsplash.get("mansioni", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.lavoratore.Cliente },
      });

      setMansioni(responseMansioni.data.data);

      let responseClienti = await unsplash.get("clienti", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
      });
      setClienti(responseClienti.data.data);

      let cliDistaccato = responseClienti.data.data.filter(
        (r) => r.ID.toString() === props.lavoratore.Distaccato
      );

      setClienteDistaccato(cliDistaccato ? cliDistaccato[0] : null);

      let responseMansioniSicurezza = await unsplash.get("mansioniSicurezza", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        params: { id: props.cliente, sede: props.lavoratore.Sede },
      });
      setMansioniSicurezza(responseMansioniSicurezza.data.data);
    };

    fetchData();



  }, []); */

    const handleChange = (e) => {
        let lav = { ...lavoratore };
        if (e.target.name === 'CF') {
            const nextCf = normalizeCfValue(e.target.value);
            if (nextCf !== normalizeCfValue(lav.CF)) lav.CFTecnico = false;
            lav.CF = nextCf;
        } else {
            lav[e.target.name] = e.target.value;
        }
        setLavoratore(lav);
    };

    const textValue = (value) => value ?? '';
    const pickerValue = (value) => (value ? moment(value) : null);

    const handleSave = async () => {
        try {
            let l = {
                ...lavoratore,
                CF: normalizeCfValue(lavoratore.CF),
                DataDiNascita: lavoratore.DataDiNascita
                    ? moment(lavoratore.DataDiNascita).format('YYYY-MM-DD')
                    : null,
                DataAssunzione: lavoratore.DataAssunzione
                    ? moment(lavoratore.DataAssunzione).format('YYYY-MM-DD')
                    : null,
                DataTermine: lavoratore.DataTermine
                    ? moment(lavoratore.DataTermine).format('YYYY-MM-DD')
                    : null,
                DataUltimaVisita: lavoratore.DataUltimaVisita
                    ? moment(lavoratore.DataUltimaVisita).format('YYYY-MM-DD')
                    : null,
                DataInserimento: lavoratore.DataInserimento
                    ? moment(lavoratore.DataInserimento).format('YYYY-MM-DD')
                    : null,
            };
            delete l.Accertamenti;

            await unsplash.put(
                'lavoratori',
                { lavoratore: l },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            await unsplash.post(
                'storico',
                {
                    tabella: 'Lavoratori',
                    key: lavoratore.ID,
                    utente: sessionStorage.getItem('username'),
                    after: l,
                    before: lavoratoreCopy,
                    operazione: 'Modifica',
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );
            await props.loadLavoratori();
            setLavoratoreCopy(lavoratore);

            setSnack({
                severity: 'success',
                messaggio: 'Lavoratore modificato con successo',
            });
            setOpenSnack(true);
        } catch {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante la creazione',
            });
            setOpenSnack(true);
        }
    };

    const loadSedi = async (cliente) => {
        let responseSedi = await unsplash.get('sedi', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: { id: cliente },
        });
        const SediSenzaCantiere = responseSedi.data.data.filter(
            (elm) => elm.Cantiere === 0
        );
        setSedi(SediSenzaCantiere);
    };

    const loadMansioneSicurezza = async (idSede) => {
        let responseMansioniSicurezza = await unsplash.get(
            'mansioniSicurezza',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { id: props.cliente, sede: idSede },
            }
        );
        setMansioniSicurezza(responseMansioniSicurezza.data.data);
    };

    return (
        <>
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Edit
                    style={{ height: '2rem', width: '2rem', color: '#2265B1' }}
                />
            </IconButton>

            <Dialog
                fullWidth
                maxWidth="2xl"
                sx={{ minHeight: '120vh', maxHeight: '120vh', my: 'auto' }}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <Grid item xs={12} style={{ width: '100%' }}>
                    <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                        <Card
                            sx={{
                                position: 'relative',
                                my: 'auto',
                                boxShadow: 'none',
                            }}
                        >
                            <CardHeader
                                sx={{ textAlign: 'center' }}
                                title={
                                    lavoratoreCopy.Nome +
                                    ' ' +
                                    lavoratoreCopy.Cognome
                                }
                                titleTypographyProps={{ variant: 'h4' }}
                            />
                        </Card>
                    </DialogTitle>
                    <DialogContent>
                        <Box
                            sx={{
                                borderBottom: 1,
                                borderColor: 'divider',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Tabs
                                value={value}
                                textColor="inherit"
                                variant="scrollable"
                                onChange={handleChangeTab}
                                aria-label="basic tabs example"
                            >
                                <Tab label="Generali" {...a11yProps(0)} />
                                {/*  <Tab label="Protocollo Sanitario" {...a11yProps(1)} />
                <Tab label="Visite" {...a11yProps(2)} />*/}
                                <Tab label="Corsi" {...a11yProps(3)} />
                                <Tab label="Allegati" {...a11yProps(4)} />
                                {/*  <Tab label="Addestramento" {...a11yProps(5)} />
                <Tab label="DPI" {...a11yProps(5)} /> */}
                            </Tabs>
                        </Box>

                        <TabPanel value={value} index={0}>
                            <Box sx={{ maxHeight: '60vh' }}>
                                {lavoratore ? (
                                    <Grid container item xs={12} spacing={2}>
                                        <Grid item xs={6} md={4}>
                                            <FormControl
                                                fullWidth
                                                required
                                                error={validation.Mansione}
                                            >
                                                <InputLabel id="demo-multiple-name-label">
                                                    Azienda
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-multiple-name-label"
                                                    id="demo-multiple-name"
                                                    value={getSelectValue(
                                                        lavoratore.Cliente,
                                                        clienti
                                                    )}
                                                    onChange={(e) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.Cliente =
                                                            e.target.value;
                                                        l.Sede = null;
                                                        l.DettaglioMedicina =
                                                            null;
                                                        setLavoratore(l);
                                                        loadSedi(
                                                            e.target.value
                                                        );
                                                    }}
                                                    input={
                                                        <OutlinedInput label="Azienda" />
                                                    }
                                                >
                                                    {clienti?.map((cli) => (
                                                        <MenuItem
                                                            key={cli.ID}
                                                            value={cli.ID}
                                                        >
                                                            {cli.RagioneSociale}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText
                                                    style={{
                                                        display:
                                                            validation.Mansione
                                                                ? ''
                                                                : 'None',
                                                    }}
                                                >
                                                    Azienda obbligatoria
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-multiple-name-label">
                                                    Sede
                                                </InputLabel>
                                                <Select
                                                    value={getSelectValue(
                                                        lavoratore.Sede,
                                                        sedi
                                                    )}
                                                    labelId="demo-multiple-name-label"
                                                    id="demo-multiple-name"
                                                    onChange={(e) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.Sede = e.target.value;
                                                        l.DettaglioMedicina =
                                                            null;
                                                        setLavoratore(l);
                                                        loadMansioneSicurezza(
                                                            e.target.value
                                                        );
                                                    }}
                                                    input={
                                                        <OutlinedInput label="Sede" />
                                                    }
                                                >
                                                    {sedi?.map((sede) => (
                                                        <MenuItem
                                                            key={sede.ID}
                                                            value={sede.ID}
                                                        >
                                                            {sede.Descrizione}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        {/* <Grid item xs={6} md={4}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-multiple-name-label">
                          Dettaglio Medicina
                        </InputLabel>
                        <Select
                          value={lavoratore.DettaglioMedicina}
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          onChange={(e) => {
                            let l = { ...lavoratore };
                            l.DettaglioMedicina = e.target.value;
                            setLavoratore(l);
                          }}
                          input={<OutlinedInput label="Dettaglio Medicina" />}
                        >
                          {dettaglioMedicina?.map((d) => {
                            let lastValue =
                              props.lavoratore?.Gruppo === "Conter"
                                ? d.Referente
                                : d.NomeMedico;
                            return (
                              <MenuItem key={d.ID} value={d.ID}>
                                {d.Blocco +
                                  " - " +
                                  d.Categoria +
                                  " - " +
                                  lastValue}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid> */}
                                        <Grid item xs={6} md={4}>
                                            <FormControl
                                                required
                                                fullWidth
                                                error={validation.Mansione}
                                            >
                                                <InputLabel id="demo-multiple-name-label">
                                                    Mansione
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-multiple-name-label"
                                                    id="demo-multiple-name"
                                                    value={getSelectValue(
                                                        lavoratore.Mansione,
                                                        mansioni
                                                    )}
                                                    onChange={(e) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.Mansione =
                                                            e.target.value;
                                                        setLavoratore(l);
                                                    }}
                                                    input={
                                                        <OutlinedInput label="Mansione" />
                                                    }
                                                >
                                                    {mansioni?.map(
                                                        (mansione) => (
                                                            <MenuItem
                                                                key={
                                                                    mansione.ID
                                                                }
                                                                value={
                                                                    mansione.ID
                                                                }
                                                            >
                                                                {
                                                                    mansione.Descrizione
                                                                }
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                                <FormHelperText
                                                    style={{
                                                        display:
                                                            validation.Mansione
                                                                ? ''
                                                                : 'None',
                                                    }}
                                                >
                                                    Mansione obbligatoria
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={6}
                                            md={4}
                                            sx={{
                                                display: 'flex',
                                                alignSelf: 'center',
                                            }}
                                        >
                                            <FormControl
                                                //required
                                                fullWidth
                                                //error={validation.Mansione}
                                            >
                                                <InputLabel id="demo-multiple-name-label">
                                                    Mansione Sicurezza
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-multiple-name-label"
                                                    id="demo-multiple-name"
                                                    value={getSelectValue(
                                                        lavoratore.MansioneSicurezza,
                                                        mansioniSicurezza
                                                    )}
                                                    onChange={(e) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.MansioneSicurezza =
                                                            e.target.value;
                                                        setLavoratore(l);
                                                    }}
                                                    input={
                                                        <OutlinedInput label="Mansione Sicurezza" />
                                                    }
                                                >
                                                    {mansioniSicurezza?.map(
                                                        (mansione) => (
                                                            <MenuItem
                                                                key={
                                                                    mansione.ID
                                                                }
                                                                value={
                                                                    mansione.ID
                                                                }
                                                            >
                                                                {
                                                                    mansione.Descrizione
                                                                }
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                                {/* <FormHelperText
                          style={{ display: validation.Mansione ? "" : "None" }}
                        >
                          Mansione obbligatoria
                        </FormHelperText> */}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <LocalizationProvider
                                                dateAdapter={DateAdapter}
                                            >
                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    ampmInClock={false}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            required: true,
                                                            error: validation.DataAssunzione,
                                                            helperText:
                                                                validation.DataAssunzione
                                                                    ? 'Data assunzione obbligatoria'
                                                                    : '',
                                                        },
                                                    }}
                                                    label="Data Assunzione"
                                                    value={pickerValue(
                                                        lavoratore.DataAssunzione
                                                    )}
                                                    onChange={(newValue) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.DataAssunzione =
                                                            newValue
                                                                ? newValue.format(
                                                                      'YYYY-MM-DD'
                                                                  )
                                                                : null;
                                                        setLavoratore(l);
                                                        //setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <LocalizationProvider
                                                dateAdapter={DateAdapter}
                                            >
                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    ampmInClock={false}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                        },
                                                    }}
                                                    label="Data Termine"
                                                    value={pickerValue(
                                                        lavoratore.DataTermine
                                                    )}
                                                    onChange={(newValue) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.DataTermine = newValue
                                                            ? newValue.format(
                                                                  'YYYY-MM-DD'
                                                              )
                                                            : null;
                                                        setLavoratore(l);
                                                        //setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Divider
                                                sx={{
                                                    color: 'rgba(58, 53, 65, 0.6)',
                                                    marginTop: '5px',
                                                    marginBottom: '15px',
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                error={validation.Nome}
                                                required
                                                value={textValue(
                                                    lavoratore.Nome
                                                )}
                                                margin="dense"
                                                name="Nome"
                                                label="Nome"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                                helperText={
                                                    validation.Nome
                                                        ? 'Nome obbligatorio'
                                                        : ''
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                error={validation.Cognome}
                                                value={textValue(
                                                    lavoratore.Cognome
                                                )}
                                                margin="dense"
                                                name="Cognome"
                                                label="Cognome"
                                                type="text"
                                                required
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                                helperText={
                                                    validation.Cognome
                                                        ? 'Cognome obbligatorio'
                                                        : ''
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <FormControl
                                                fullWidth
                                                sx={{ marginTop: '8px' }}
                                            >
                                                <InputLabel id="Sesso">
                                                    Sesso
                                                </InputLabel>
                                                <Select
                                                    label="Sesso"
                                                    labelId="Sesso"
                                                    id="demo-simple-select"
                                                    value={getSelectValue(
                                                        lavoratore.Sesso,
                                                        [1, 2]
                                                    )}
                                                    onChange={(e) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.Sesso =
                                                            e.target.value;
                                                        setLavoratore(l);
                                                    }}
                                                >
                                                    <MenuItem value={1}>
                                                        Maschio
                                                    </MenuItem>
                                                    <MenuItem value={2}>
                                                        Femmina
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Email
                                                )}
                                                margin="dense"
                                                name="Email"
                                                label="Email"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Telefono
                                                )}
                                                margin="dense"
                                                name="Telefono"
                                                label="Telefono"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(lavoratore.CF)}
                                                margin="dense"
                                                name="CF"
                                                label={
                                                    cfStatus.status ===
                                                    'technical'
                                                        ? 'Codice Fiscale · CF tecnico'
                                                        : 'Codice Fiscale'
                                                }
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                                helperText={
                                                    cfStatus.status ===
                                                        'mismatch' ||
                                                    cfStatus.status ===
                                                        'invalid' ||
                                                    cfStatus.status ===
                                                        'technical'
                                                        ? cfStatus.message
                                                        : ''
                                                }
                                                InputProps={{
                                                    endAdornment:
                                                        cfStatus.status ===
                                                        'verified' ? (
                                                            <InputAdornment position="end">
                                                                <Tooltip title="CF verificato">
                                                                    <CheckCircle
                                                                        sx={{
                                                                            color: '#2e7d32',
                                                                            fontSize:
                                                                                '1.2rem',
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ) : cfStatus.status ===
                                                              'mismatch' ||
                                                          cfStatus.status ===
                                                              'invalid' ? (
                                                            <InputAdornment position="end">
                                                                <Tooltip
                                                                    title={
                                                                        cfStatus.message
                                                                    }
                                                                >
                                                                    <Error
                                                                        sx={{
                                                                            color: '#d32f2f',
                                                                            fontSize:
                                                                                '1.2rem',
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ) : null,
                                                }}
                                                inputProps={{ maxLength: 16 }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.LuogoDiNascita
                                                )}
                                                margin="dense"
                                                name="LuogoDiNascita"
                                                label="Luogo di Nascita"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <LocalizationProvider
                                                dateAdapter={DateAdapter}
                                            >
                                                <DatePicker
                                                    sx={{ width: '100%' }}
                                                    ampmInClock={false}
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                        },
                                                    }}
                                                    label="Data Di Nascita"
                                                    value={pickerValue(
                                                        lavoratore.DataDiNascita
                                                    )}
                                                    onChange={(newValue) => {
                                                        let l = {
                                                            ...lavoratore,
                                                        };
                                                        l.DataDiNascita =
                                                            newValue
                                                                ? newValue.format(
                                                                      'YYYY-MM-DD'
                                                                  )
                                                                : null;
                                                        setLavoratore(l);
                                                        //setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Matricola
                                                )}
                                                margin="dense"
                                                name="Matricola"
                                                label="Matricola"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Qualifica
                                                )}
                                                margin="dense"
                                                name="Qualifica"
                                                label="Qualifica"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Livello
                                                )}
                                                margin="dense"
                                                name="Livello"
                                                label="Livello"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.TipoRapporto
                                                )}
                                                margin="dense"
                                                name="TipoRapporto"
                                                label="Tipo Rapporto"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.TipoPartTime
                                                )}
                                                margin="dense"
                                                name="TipoPartTime"
                                                label="Tipo Part Time"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={
                                                    lavoratore.ProvinciaDiNascita
                                                }
                                                margin="dense"
                                                name="ProvinciaDiNascita"
                                                label="Provincia Di Nascita"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.Residenza
                                                )}
                                                margin="dense"
                                                name="Residenza"
                                                label="Residenza"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        <Grid item xs={6} md={4}>
                                            <TextField
                                                value={textValue(
                                                    lavoratore.CentroDiCosto
                                                )}
                                                margin="dense"
                                                name="CentroDiCosto"
                                                label="Centro Di Costo"
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                        {/*




                    <Grid item xs={6} md={4}>


                      <TextField
                        value={lavoratore.Distaccato}
                        margin="dense"
                        name="Distaccato"
                        label="Distaccato"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={6} md={4} sx={{ marginTop: "8px" }}>
                      <LocalizationProvider dateAdapter={DateAdapter}>
                        <DatePicker
                        sx={{width: "100%"}}
                          ampmInClock={false}
                          renderInput={(props) => (
                            <TextField
                              fullWidth
                              {...props}
                            />
                          )}
                          label="Data Fatturazione Costi Gestione"
                          value={moment(lavoratore.DtaCostiGestione)}
                          onChange={(newValue) => {
                            let l = { ...lavoratore };
                            l.DtaCostiGestione = newValue
                              ? newValue.format("YYYY-MM-DD")
                              : null;
                            setLavoratore(l);
                            //setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6} md={4}>
                      <TextField
                        value={lavoratore.GPCSC}
                        margin="dense"
                        name="GPCSC"
                        label="Cartella Sanitaria Cessati"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={6} md={4}>
                      <TextField
                        value={lavoratore.GPCSCspesevive}
                        margin="dense"
                        name="GPCSCspesevive"
                        label="Cartella Sanitaria Cessati (Spese Vive)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={6} md={4}>
                      <TextField
                        value={lavoratore.DescrizioneMalattiaProfessionale}
                        margin="dense"
                        name="DescrizioneMalattiaProfessionale"
                        label="Descrizione Malattia Professionale"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={handleChange}
                      />
                    </Grid>
                    <FormControlLabel
                        control={
                          <Checkbox
                            name="StoricoGPCSC"
                            checked={
                              lavoratore.StoricoGPCSC === 1 ? true : false
                            }
                            onChange={(e) => {
                              let l = { ...lavoratore };
                              l.StoricoGPCSC = e.target.checked ? 1 : 0;
                              setLavoratore(l);
                            }}
                          />
                        }
                        label="Storico Gestione Cartella Sanitaria Cessati"
                      />

<FormControlLabel
                        control={
                          <Checkbox
                            name="MalattiaProfessionale"
                            checked={
                              lavoratore.MalattiaProfessionale === 1
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              let l = { ...lavoratore };
                              l.MalattiaProfessionale = e.target.checked
                                ? 1
                                : 0;
                              setLavoratore(l);
                            }}
                          />
                        }
                        label="Malattia Professionale"
                      />


                    */}
                                        <Grid item xs={6} md={8}>
                                            <TextField
                                                //rows={3}
                                                value={textValue(
                                                    lavoratore.Note
                                                )}
                                                margin="dense"
                                                name="Note"
                                                label="Note"
                                                multiline
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                        {/*<Grid item xs={6} md={4}>
                      {lavoratore.IDDistacco ? (
                        <ConcludiDistacco
                          loadLavoratori={props.loadLavoratori}
                          handleCloseFather={handleClose}
                          lavoratore={props.lavoratore}
                          setSnack={setSnack}
                          setOpenSnack={setOpenSnack}
                        />
                      ) : (
                        <Distacca
                          clienti={clienti}
                          loadLavoratori={props.loadLavoratori}
                          handleCloseFather={handleClose}
                          lavoratore={props.lavoratore}
                          setSnack={setSnack}
                          setOpenSnack={setOpenSnack}
                        />
                      )}
                    </Grid>*/}
                                        <Grid item xs={12} sx={{ mt: 1 }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="Somministrato"
                                                        disabled={true}
                                                        checked={
                                                            lavoratore.Somministrato ===
                                                            1
                                                                ? true
                                                                : false
                                                        }
                                                        onChange={(e) => {
                                                            let l = {
                                                                ...lavoratore,
                                                            };
                                                            l.Somministrato = e
                                                                .target.checked
                                                                ? 1
                                                                : 0;
                                                            setLavoratore(l);
                                                        }}
                                                    />
                                                }
                                                label="Somministrato"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name="Alert"
                                                        checked={
                                                            lavoratore.Alert ===
                                                            1
                                                                ? true
                                                                : false
                                                        }
                                                        onChange={(e) => {
                                                            let l = {
                                                                ...lavoratore,
                                                            };
                                                            l.Alert = e.target
                                                                .checked
                                                                ? 1
                                                                : 0;
                                                            setLavoratore(l);
                                                        }}
                                                    />
                                                }
                                                label="Includi in Alert"
                                            />
                                        </Grid>

                                        <Grid
                                            xs={12}
                                            item
                                            sx={{
                                                display: 'flex',
                                                my: 2,
                                                justifyContent: 'space-between',
                                            }}
                                        ></Grid>
                                    </Grid>
                                ) : (
                                    ''
                                )}
                            </Box>
                        </TabPanel>
                        {/*<TabPanel value={value} index={1}>
              <Box sx={{ maxHeight: "60vh" }}>
                <ProtocolloSanitarioLavoratore
                  lavoratore={props.lavoratore}
                  idAzienda={props.lavoratore.Cliente}
                />
              </Box>
            </TabPanel> */}
                        {/* ASTM <TabPanel value={value} index={2}>
              <Box sx={{ maxHeight: "60vh" }}>
                <VisiteMedicheLavoratore
                  lavoratore={props.lavoratore.ID}
                  datiLavoratore={props.lavoratore}
                  cliente={props.lavoratore.Cliente}
                />
              </Box>
            </TabPanel>

            */}
                        <TabPanel value={value} index={1}>
                            <Box sx={{ maxHeight: '60vh' }}>
                                <CorsiLavoratore
                                    idLavoratore={props.lavoratore.ID}
                                    idAzienda={props.lavoratore.Cliente}
                                    lavoratore={props.lavoratore}
                                />
                            </Box>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <Box sx={{ maxHeight: '60vh' }}>
                                <Allegati
                                    idLavoratore={props.lavoratore.ID}
                                    id={props.lavoratore.ID}
                                    colonna="Lavoratore"
                                    nomeLav={
                                        lavoratoreCopy.Nome +
                                        ' ' +
                                        lavoratoreCopy.Cognome
                                    }
                                />
                            </Box>
                        </TabPanel>
                        {/*  <TabPanel value={value} index={3}>
              <Box sx={{ maxHeight: "60vh" }}>
                <AddestramentoLavoratori
                  idLavoratore={props.lavoratore.ID}
                  lavoratore={props.lavoratore}
                  cliente={props.dati}
                />
              </Box>
            </TabPanel>
             <TabPanel value={value} index={6}>
              <StampaDPI lavoratore={props.lavoratore} cliente={props.dati} />
            </TabPanel> */}
                    </DialogContent>
                </Grid>
                <DialogActions>
                    {value === 0 && (
                        <>
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={<Close />}
                                onClick={() => handleClose()}
                            >
                                Chiudi
                            </Button>
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                startIcon={<Check />}
                                onClick={handleSave}
                            >
                                Salva
                            </Button>{' '}
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function getSelectValue(value, options, optionKey = 'ID') {
    if (value === null || value === undefined) {
        return '';
    }
    if (!Array.isArray(options) || options.length === 0) {
        return '';
    }
    const exists = options.some((opt) => {
        if (opt && typeof opt === 'object') {
            return opt[optionKey] === value;
        }
        return opt === value;
    });
    return exists ? value : '';
}

export default DettaglioLavoratore;
